import { useEffect, useState } from 'react';
import { observeContentChanges } from './observe-content-changes';

const OVERFLOW_TOLERANCE_PX = 1;

/** Tracks whether an element's rendered content is vertically clipped. */
export function useIsOverflowing(element: HTMLElement | null): boolean {
  const [isOverflowing, setIsOverflowing] = useState(false);

  // eslint-disable-next-line no-restricted-syntax -- DOM overflow is imperative layout state observed after render
  useEffect(() => {
    if (!element) {
      setIsOverflowing(false);
      return;
    }

    return observeContentChanges(element, () => {
      setIsOverflowing(
        element.scrollHeight > element.clientHeight + OVERFLOW_TOLERANCE_PX,
      );
    });
  }, [element]);

  return isOverflowing;
}
